import * as actions from "./partner.actions";
import * as types from "./partner.actionTypes";
import { ActionType, createReducer } from "typesafe-actions";
import { PartnerReducerType } from "./types";

export type PartnerActions = ActionType<typeof actions>;

export const initialState: PartnerReducerType = {
  error: null,
  listPartner: [],
  isLoading: false,
  errorMessage: '',
  redirectQueue: '',
  selectedPartner: null,
};

export const PartnerReducer = createReducer<
PartnerReducerType,
  PartnerActions
>(initialState)
  // GET JENIS DOKUMEN
  .handleAction(actions.getPartnerAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: ''
  }))
  .handleAction(actions.getPartnerAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    errorMessage: '',
    redirectQueue: '',
    listPartner: action.payload.data.items,
  }))
  .handleAction(actions.getPartnerAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    redirectQueue: '',
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // GET DETAIL PARTNER
  .handleAction(actions.getDetailPartnerAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: ''
  }))
  .handleAction(actions.getDetailPartnerAsync.success, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    isLoading: false,
    selectedPartner: action.payload.data,
  }))
  .handleAction(actions.getDetailPartnerAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // UPDATE JENIS DOKUMEN
  .handleAction(actions.updatePartnerAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: ''
  }))
  .handleAction(actions.updatePartnerAsync.success, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    isLoading: false,
    redirectQueue: '/partner',
  }))
  .handleAction(actions.updatePartnerAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    redirectQueue: '',
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // CREATE JENIS DOKUMEN
  .handleAction(actions.createPartnerAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    errorMessage: '',
    redirectQueue: ''
  }))
  .handleAction(actions.createPartnerAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    errorMessage: '',
    redirectQueue: '/partner',
  }))
  .handleAction(actions.createPartnerAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    redirectQueue: '',
    error: action.payload,
    errorMessage: action.payload.message,
  }))

  // OTHER SELECTORS
  .handleAction(types.INITIALIZE_CREATE_PARTNER as any, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    selectedPartner: action.payload.partner,
  }))
  .handleAction(types.SELECT_PARTNER as any, (state, action) => ({
    ...state,
    error: null,
    errorMessage: '',
    redirectQueue: '',
    selectedPartner: action.payload.partner,
  }))
  .handleAction(types.UPDATE_NAME as any, (state, action) => ({
    ...state,
    selectedPartner: (() => {
      if (state.selectedPartner) {
        return {
          ...state.selectedPartner,
          CO_NAME: action.payload.value
        };
      } else {
        return null;
      }
    })(),
  }))
  .handleAction(types.UPDATE_ADDRESS as any, (state, action) => ({
    ...state,
    selectedPartner: (() => {
      if (state.selectedPartner) {
        return {
          ...state.selectedPartner,
          CO_ALAMAT: action.payload.value
        };
      } else {
        return null;
      }
    })(),
  }))
  .handleAction(types.UPDATE_WEBSITE as any, (state, action) => ({
    ...state,
    selectedPartner: (() => {
      if (state.selectedPartner) {
        return {
          ...state.selectedPartner,
          CO_WEB: action.payload.value
        };
      } else {
        return null;
      }
    })(),
  }))
  .handleAction(types.UPDATE_PHONE as any, (state, action) => ({
    ...state,
    selectedPartner: (() => {
      if (state.selectedPartner) {
        return {
          ...state.selectedPartner,
          CO_TELP: action.payload.value
        };
      } else {
        return null;
      }
    })(),
  }))
  .handleAction(types.UPDATE_CITY as any, (state, action) => ({
    ...state,
    selectedPartner: (() => {
      if (state.selectedPartner) {
        return {
          ...state.selectedPartner,
          CO_KOTA: action.payload.value
        };
      } else {
        return null;
      }
    })(),
  }))
  .handleAction(types.UPDATE_POSTCODE as any, (state, action) => ({
    ...state,
    selectedPartner: (() => {
      if (state.selectedPartner) {
        return {
          ...state.selectedPartner,
          CO_KODEPOS: action.payload.value
        };
      } else {
        return null;
      }
    })(),
  }))
  .handleAction(types.UPDATE_COUNTRY as any, (state, action) => ({
    ...state,
    selectedPartner: (() => {
      if (state.selectedPartner) {
        return {
          ...state.selectedPartner,
          CO_NEGARA_ID: action.payload.newId,
          CO_NEGARA_DETAIL: action.payload.newDetail
        };
      } else {
        return null;
      }
    })(),
  }))
  .handleAction(types.UPDATE_TYPE as any, (state, action) => ({
    ...state,
    selectedPartner: (() => {
      if (state.selectedPartner) {
        return {
          ...state.selectedPartner,
          CO_TYP_ID: action.payload.newId,
          CO_TYP_DETAIL: action.payload.newDetail
        };
      } else {
        return null;
      }
    })(),
  }))
  .handleAction(types.UPDATE_PIC_NAME as any, (state, action) => ({
    ...state,
    selectedPartner: (() => {
      if (state.selectedPartner) {
        return {
          ...state.selectedPartner,
          CO_PIC_NAME: action.payload.value
        };
      } else {
        return null;
      }
    })(),
  }))
  .handleAction(types.UPDATE_PIC_EMAIL as any, (state, action) => ({
    ...state,
    selectedPartner: (() => {
      if (state.selectedPartner) {
        return {
          ...state.selectedPartner,
          CO_PIC_EMAIL: action.payload.value
        };
      } else {
        return null;
      }
    })(),
  }))
  .handleAction(types.UPDATE_PIC_PHONE as any, (state, action) => ({
    ...state,
    selectedPartner: (() => {
      if (state.selectedPartner) {
        return {
          ...state.selectedPartner,
          CO_PIC_PHONE: action.payload.value
        };
      } else {
        return null;
      }
    })(),
  }))
  .handleAction(types.UPDATE_PIC_POSITION as any, (state, action) => ({
    ...state,
    selectedPartner: (() => {
      if (state.selectedPartner) {
        return {
          ...state.selectedPartner,
          CO_PIC_JOB_TITLE: action.payload.value
        };
      } else {
        return null;
      }
    })(),
  }))
  .handleAction(types.UPDATE_PIC_DEPARTMENT as any, (state, action) => ({
    ...state,
    selectedPartner: (() => {
      if (state.selectedPartner) {
        return {
          ...state.selectedPartner,
          CO_PIC_DEPT: action.payload.value
        };
      } else {
        return null;
      }
    })(),
  }))